// src/routes/notFoundRoute.jsx
import { Navigate } from 'react-router-dom';

export const notFoundRoute = {
  path: '*',
  element: <Navigate to="/login" replace />
};